/* src/app/components/shop/products/product-vertical/product-vertical.component.scss */
/*# sourceMappingURL=product-vertical.component.css.map */
